import React from 'react';
import PropTypes from 'prop-types';

export default class ExpandImageModal extends React.Component {
  static propTypes = {
    onClose: PropTypes.func.isRequired,
    assetURL: PropTypes.string,
    alt: PropTypes.string
  };

  render() {
    const { onClose, assetURL, alt } = this.props;

    return (
      <div onClick={(event) => (event.target == event.currentTarget ? onClose() : null)} style={styles.addModal}>
        <div style={styles.innerWrap}>
          <img src={assetURL} alt={alt} style={styles.imagePreview}/>
        </div>
      </div>
    );
  }
}

const styles = {
  addModal: {
    position: 'fixed',
    left: '0px',
    top: '0px',
    bottom: '0px',
    right: '0px',
    background: 'rgba(0, 0, 0, 0.2)',
    zIndex: '9',
    display: 'flex'
  },
  innerWrap: {
    margin: 'auto',
    background: '#FAFAFA',
    textAlign: 'center'
  },
  imagePreview: {
    width: '100%',
    maxWidth: '1200px',
    display: 'inline-block'
  }
};
